/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TranslatePipe as ɵa} from './lib/translate/translate.pipe';
export {UTILS_CONFIG as ɵb} from './lib/utils/utils.config';